import { zidian } from '@/api/livestocker';
import common from '@/views/poultryStorage/commone/common.js';
export default {
  isNull(value) {
    return value === '' || value === undefined || value === null;
  },
  isNaN(value) {
    return Number.isNaN(value);
  },
  isMessage(self, msg, type) {
    self.$message({
      type: type || 'warning',
      message: msg,
      duration: 3000
    });
  },
  isArray(str) {
    return Array.isArray(str);
  },
  isObject(obj1, obj2) {
    return Object.assign(obj1, obj2);
  },
  isString(str) {
    return typeof str === 'string';
  },
  // 时间戳转换
  formatDateTime(timeStamp, type, number, noSecond) {
    let date = new Date();
    date.setTime(timeStamp);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    let h = date.getHours();
    if (type) {
      h = 24;
    }
    h = h < 10 ? '0' + h : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();
    minute = minute < 10 ? '0' + minute : minute;
    second = second < 10 ? '0' + second : second;
    if (number) {
      return y + '-' + m + '-' + d;
    }
    if (noSecond) {
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
    }
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  },
  // 获取年月日
  formatDateTimeYear(timeStamp, type) {
    let date = new Date();
    date.setTime(timeStamp);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    if (type == 2) return y + '-' + m + '-' + d;
    if (type) {
      return y + '-' + m + '-' + d + ' 23:59:59';
    }
    return y + '-' + m + '-' + d + ' 00:00:00';
  },
  formatDateTimeYYR(timeStamp) {
    let date = new Date();
    date.setTime(timeStamp);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  },
  // 查询字典
  isDictionary(_params) {
    const _distionary = new Promise(function (resolve, reject) {
      zidian(_params)
        .then(res => {
          const { code, data, msg } = res.data;
          if (Number(code) === 0) {
            resolve(data);
          } else common.isMessage(msg);
        })
        .catch(err => {
          reject(err);
        });
    });
    return _distionary;
  },
  // 根据返回信息提取区县信息
  districtsAndCounties(address) {
    if (address) {
      const _rgx = /(北京市|天津市|上海市|重庆市|[^省]+省|[^自治区]+自治区|[^市]+市)/g;
      let _address = address.replace(_rgx, '');
      const _rgx1 = /([^区]+区|[^县]+县|[^旗]+旗)/;
      _address = _address.match(_rgx1);
      // 如果匹配到区县信息，返回
      if (_address) {
        return _address[0];
      }
      return '';
    }
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/views/poultryStorage/commone/common.js